import { IFollowUpSurveyForList } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IFollowUpSurveyForList,
    onConfirm: () => void,
    onCancel: () => void
}

const MarkOrdersSent = (props: IProps) => {
    let fullName = props.data != null ? props.data.firstName + ' ' + props.data.lastName:'';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Lab Orders Sent for <span style={{ color: 'darkgreen', fontWeight: 'bold' }}>{fullName}</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Please confirm that you wish to mark lab orders sent for donor <strong>{fullName}</strong>.
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm Sent</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MarkOrdersSent;